import { useMemo } from 'react';
import { SpreadsheetConfig } from 'components/ScalarSpreadsheet/utilities/SpreadsheetConfig';
import conditions from 'pages/CapTable/cap-table/components/convertible-notes-ledger/config/conditions';
import {
  afterCellChanged,
  customValidations,
  getRowConfig,
} from 'pages/CapTable/cap-table/components/convertible-notes-ledger/config/index';
import parser from 'pages/CapTable/cap-table/components/convertible-notes-ledger/config/parser';
import reverseParser from 'pages/CapTable/cap-table/components/convertible-notes-ledger/config/reverseParser';
import totalParser from 'pages/CapTable/cap-table/components/convertible-notes-ledger/config/totalParser';
import { UseConvertibleNoteSheetProps } from 'pages/CapTable/cap-table/components/convertible-notes-ledger/config/useConvertibleNoteSheet/useConvertibleNoteSheet.props';

const useConvertibleNoteSheet = ({
  selectedMeasurementDate,
  columns,
  convertibleNotesFieldAttrs,
  isDisabled,
  fundOwnership,
}: UseConvertibleNoteSheetProps) => {
  const rowConfig = useMemo(() => {
    if (selectedMeasurementDate) {
      return getRowConfig(selectedMeasurementDate, isDisabled);
    }
  }, [isDisabled, selectedMeasurementDate]);

  const tableTerms = useMemo(
    () => ({
      tableName: 'Note Ledger',
      tableSlug: 'convertible-note-ledger',
      columnName: 'Note',
      pluralColumnName: 'data',
    }),
    []
  );

  const sheet = useMemo(() => new SpreadsheetConfig({
    rowConfig,
    parser,
    columns,
    totalParser,
    afterCellChanged,
    fieldAttributes: convertibleNotesFieldAttrs,
    reverseParser,
    conditions,
    validations: customValidations,
    allowEmptyValues: false,
    currencyFormatter: true,
    tableTerms,
    page: 'captable',
    name: 'convertible_notes_ledger',
    allowDeleteColumn: true,
    hasColTitle: true,
    showToolbar: true,
    showTotalColumn: true,
    tableData: {
      isDisabled,
      fund_ownership: fundOwnership,
    },
  }), [columns, rowConfig, convertibleNotesFieldAttrs, tableTerms, isDisabled, fundOwnership]);

  return {
    sheet,
  };
};

export default useConvertibleNoteSheet;
